<header class="site-header">
  <div class="site-header-start">
    <a routerLink="/" class="brand">
      <img src="icon.svg" alt="Ball der Alt-Schotten" class="brand-logo" />
    </a>
    <a routerLink="/datenschutz" class="privacy-link">Datenschutz</a>
  </div>

  <nav class="site-nav">
    <span class="copyright">© Janko Glavic 2026</span>
    @if (authStore.isAuthenticated()) {
      @if (authStore.isAdmin()) {
        <a routerLink="/admin">Admin</a>
      } @else {
        <a routerLink="/me">Mein Bereich</a>
      }
      <button type="button" class="btn btn-secondary" (click)="logout()">Abmelden</button>
    } @else if (isLoginPage()) {
      <a routerLink="/register">Registrieren</a>
    } @else {
      <a routerLink="/login">Anmelden</a>
    }
  </nav>
</header>

<main>
  <router-outlet />
</main>
